import { NgClass, NgFor, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  standalone: true,
  selector: 'dcc-chip',
  template: `
    <div class="chip" (click)="toggleDropDown()">
      <i class="lx-icon" [class]="iconClass"></i>
      <span class="value">{{ value }}</span>

      <!-- Dropdown -->
      <i
        class="lx-icon"
        [ngClass]="{
          'lx-close-x': !showDropDown,
          'lx-chevron-lrg-up': showDropDown,
        }"
        (click)="handleIconClick($event)"
      ></i>
    </div>

    <ng-container *ngIf="showDropDown">
      <div
        *ngFor="let item of dropDownItems; let i = index; let last = last"
        class="dropdown"
        [ngClass]="{ 'first-item': i === 0, 'last-item': last }"
      >
        <div class="dropdown-item" (click)="toggleSelection(item)">
          <input
            type="checkbox"
            [(ngModel)]="item.selected"
            (change)="emitSelection()"
            (click)="$event.stopPropagation()"
          />
          <span>{{ item.name }}</span>
        </div>
      </div>
    </ng-container>
  `,
  styleUrls: ['chip.component.scss'],
  imports: [NgClass, FormsModule, NgIf, NgFor],
})
export class ChipComponent implements OnInit {
  @Input() icon: string;
  @Input() value: string;
  @Input() item: any;
  @Input() selectableItems: any[];
  @Output() delete = new EventEmitter<any>();
  @Output() selectionChanged = new EventEmitter<any>();

  selectedItem: any;
  showDropDown = false;
  dropDownItems: any[];

  protected get iconClass(): string {
    return `lx-${this.icon}`;
  }

  ngOnInit() {
    if (this.selectableItems && this.selectableItems.length > 0) {
      this.createDropDownItems();
    }
  }

  close() {
    this.delete.emit(this.item);
  }

  toggleDropDown() {
    if (this.dropDownItems && this.dropDownItems.length > 0) {
      this.showDropDown = !this.showDropDown;
    }
  }

  handleIconClick(event: Event) {
    event.stopPropagation();
    if (!this.showDropDown) {
      this.close();
    } else {
      this.showDropDown = false;
    }
  }

  toggleSelection(item: any) {
    item.selected = !item.selected;
    this.emitSelection();
  }

  emitSelection() {
    const selectedItems = this.dropDownItems.filter((item) => item.selected);
    this.selectionChanged.emit(selectedItems);
  }

  private createDropDownItems() {
    this.dropDownItems = this.selectableItems.map((item) => {
      return {
        name: item,
        selected: false,
      };
    });
  }
}
